// tslint:disable
export var AddressType;
(function (AddressType) {
    // UNKNOWN
    AddressType[AddressType["UNKNOWN"] = 0] = "UNKNOWN";
    // CORPORATE HEADQUARTERS
    AddressType[AddressType["CORPORATEHEADQUARTERS"] = 1] = "CORPORATEHEADQUARTERS";
    // SALES OFFICE
    AddressType[AddressType["SALESOFFICE"] = 2] = "SALESOFFICE";
    // RESIDENTIAL ADDRESS
    AddressType[AddressType["RESIDENTIALADDRESS"] = 3] = "RESIDENTIALADDRESS";
    // WORK ADDRESS
    AddressType[AddressType["WORKADDRESS"] = 4] = "WORKADDRESS";
    // SEASONAL ADDRESS
    AddressType[AddressType["SEASONALADDRESS"] = 5] = "SEASONALADDRESS";
    // MAILING ADDRESS
    AddressType[AddressType["MAILINGADDRESS"] = 6] = "MAILINGADDRESS";
    // BILLING ADDRESS
    AddressType[AddressType["BILLINGADDRESS"] = 7] = "BILLINGADDRESS";
    // SHIPPING ADDRESS
    AddressType[AddressType["SHIPPINGADDRESS"] = 8] = "SHIPPINGADDRESS";
})(AddressType || (AddressType = {}));
//# sourceMappingURL=AddressType.js.map